import React from 'react';
import UseGetDashBoardData from '../../../../Components/Hooks/useDashboardData';

function Ticket() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/open-tickets-overview`);

  return (
    <div className="col-span-2 bg-gradient-to-r from-white to-gray-50 h-[22vh]  w-full p-4 rounded-2xl shadow-lg  flex flex-col justify-between">
      <div className="flex justify-between items-center">
        <h3 className="text-gray-700 text-sm font-semibold">Open Tickets</h3>
        <div className="bg-red-100 text-red-500 p-2.5 rounded-full shadow-sm">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M10.29 3.86l-8.29 14.14a2 2 0 0 0 1.71 3h16a2 2 0 0 0 1.71-3l-8.29-14.14a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12" y2="17"></line>
          </svg>
        </div>
      </div>

      {/* Ticket Count */}
      <div>
        <p className="text-xl font-bold text-gray-800">{data?.total}</p>
        {/* <p className="text-xs text-gray-500">Total Open Tickets</p> */}
      </div>

      {/* High Priority Info */}
      <div className='mt-2'>
        <span className="text-xs bg-red-100 text-red-600 px-3 py-1 rounded-lg font-medium">
          {data?.high_priority} High Priority
        </span>
      </div>
    </div>
  );
}

export default Ticket;
